export default __webpack_public_path__ + "static/media/mixrCup.40389d09.png";